import './styles.css'
import { AlertPopoutContent } from '../alert-console/AlertPopoutContent'
import { MemberPopoutContent } from '../members/MemberPopoutContent'
import { EdrPopoutContent } from '../activity/EdrPopoutContent'
import { DeepPopoutContent } from '../activity/DeepPopoutContent'
import { DomainBlocklistPopoutContent } from '../domain-blocklist/DomainBlocklistPopoutContent'
import AdminPopoutContent from '../admin-password/AdminPopoutContent'
import AuditPopoutContent from '../settings/AuditPopoutContent'
import { DomainBlocklistLogsPopoutContent } from '../domain-blocklist/DomainBlocklistLogsPopoutContent'
import { inPov } from '../../utils/session'
import { useSelector } from 'react-redux'
import { selectUser } from '../../reducers/users'
import { HEADER_HEIGHT_WITH_TRIAL } from '../../strings/consts'
import DeviceEventPopoutContent from '../devices/DeviceEventPopout'
import DeviceForensicPopoutContent from '../devices/DeviceForensicPopout'

interface IPopoutProps {
  setShowPopout: (show: boolean) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  popoutData: any
  contentScreen: string
  setShowResolveModal?: (show: boolean) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  triggerEvent?: (event?: string, data?: any) => void
  heightOffset?: number
}

const Popout = (props: IPopoutProps) => {
  const { setShowPopout, contentScreen, popoutData, setShowResolveModal, triggerEvent, heightOffset = 74 } = props
  const { session } = useSelector(selectUser)

  const determineContent = () => {
    if (popoutData) {
      switch (contentScreen) {
        case 'EDR':
          return <EdrPopoutContent setShowPopout={setShowPopout} popoutData={popoutData} />
        case 'DEEP':
          return <DeepPopoutContent setShowPopout={setShowPopout} popoutData={popoutData} />
        case 'ALERT':
          return (
            <AlertPopoutContent
              setShowPopout={setShowPopout}
              popoutData={popoutData}
              setShowResolveModal={setShowResolveModal!}
            />
          )
        case 'MEMBERS':
          return <MemberPopoutContent setShowPopout={setShowPopout} popoutData={popoutData} />
        case 'DOMAINS':
          return <DomainBlocklistPopoutContent setShowPopout={setShowPopout} popoutData={popoutData} />
        case 'REQUESTS':
          return <DomainBlocklistLogsPopoutContent setShowPopout={setShowPopout} popoutData={popoutData} />
        case 'AUDIT':
          return <AuditPopoutContent setShowPopout={setShowPopout} popoutData={popoutData} />
        case 'ADMIN':
          return (
            <AdminPopoutContent setShowPopout={setShowPopout} triggerEvent={triggerEvent} popoutData={popoutData} />
          )
        case 'DEVICE_EVENT':
          return <DeviceEventPopoutContent setShowPopout={setShowPopout} popoutData={popoutData} />
        case 'DEVICE_FORENSIC':
          return <DeviceForensicPopoutContent setShowPopout={setShowPopout} popoutData={popoutData} />
        default:
          return null
      }
    } else {
      return null
    }
  }

  return (
    <div
      className={`${heightOffset > 0 ? `h-[calc(100vh_-_${heightOffset}px)] absolute` : 'top-0 h-screen fixed'} w-[400px] right-0 bg-mainBackground z-50 border-t border-l border-mainBorder shadow-2xl overflow-y-auto`}
      id="scrollablePopout"
      style={{
        height: inPov(session) ? `calc(100vh - ${HEADER_HEIGHT_WITH_TRIAL})` : `calc(100vh - ${heightOffset}px)`,
        top: `${inPov(session) ? HEADER_HEIGHT_WITH_TRIAL : heightOffset}px`,
      }}
    >
      {determineContent()}
    </div>
  )
}

export default Popout
